export default __webpack_public_path__ + "static/media/luxdedo.daf597dd.png";